import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import DashboardFormLayout from './containers/Form';

export default function DashboardLayout() {
  return <Router>
    <PrivateRoute path="/path/dashboard" component={DashboardFormLayout} />
  </Router>
}
